'use client'

import { useEffect, useRef, type ReactNode } from 'react'
import { useCapacitorBridge } from '@/components/capacitor-bridge-provider'
import { useAuth } from '@/contexts/auth-context'
import { configureRevenueCat, logInRevenueCat } from '@/lib/revenuecat-client'

interface RevenueCatProviderProps {
  children: ReactNode
}

/**
 * Configures RevenueCat when running in Capacitor and bridge is ready.
 * Uses appUserID from auth when available so webhooks can attribute purchases to the parent.
 */
export function RevenueCatProvider({ children }: RevenueCatProviderProps) {
  const { isCapacitor, isReady } = useCapacitorBridge()
  const { user } = useAuth()
  const configuredRef = useRef(false)

  useEffect(() => {
    if (!isCapacitor || !isReady) return
    const userId = user?.id
    if (!configuredRef.current) {
      configuredRef.current = true
      configureRevenueCat(userId ?? undefined).catch(() => {})
    }
    if (userId) {
      logInRevenueCat(userId).catch(() => {})
    }
  }, [isCapacitor, isReady, user?.id])

  return <>{children}</>
}
